import { useContext } from "react";
import { PspContext } from "../config/contexts";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { translate } from "../config/translator";
import PspButton from "../components/pspButton/PspButton";
import { setCookieConsentStorage } from "../config/utils";
import { Link, useLocation } from "react-router-dom";

type CookieConsentDialogProps = {
  isOpen: boolean;
};

export default function CookieConsentDialog({
  isOpen,
}: CookieConsentDialogProps) {
  // -----------------------------------------------------------------------------
  // GENERAL
  // -----------------------------------------------------------------------------
  const {
    lang,
    user,

    setMfaSetupState: setMfaSetupOpen,
    setCookieConsentFunctionalOnly,
    setCookieConsentDialogOpen,
  } = useContext(PspContext);
  const location = useLocation();

  // -----------------------------------------------------------------------------
  // CALLBACK FUNCTIONS
  // -----------------------------------------------------------------------------
  function checkMfa() {
    if (user && !user.mfaEnabled && user.mfaRequired) {
      setMfaSetupOpen("firstSetup");
    }
  }

  function onConsentAllCookies() {
    setCookieConsentStorage({ essentialOnly: false });
    setCookieConsentFunctionalOnly(false);
    setCookieConsentDialogOpen(false);
    checkMfa();
  }

  function onConsentFunctionalCookiesOnly() {
    setCookieConsentStorage({ essentialOnly: true });
    setCookieConsentFunctionalOnly(true);
    setCookieConsentDialogOpen(false);
    checkMfa();
  }

  // -----------------------------------------------------------------------------
  // COMPONENTS
  // -----------------------------------------------------------------------------
  return (
    <Dialog
      open={
        isOpen &&
        !(
          location.pathname.startsWith("/cookie-policy") ||
          location.pathname.startsWith("/privacy-policy")
        )
      }
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{translate("cookieDialogTitle", lang)}</DialogTitle>
          <DialogContent>
            <span>
              <p className="mb-4">
                {translate("cookieDialogBody", lang) + " "}
                <span>
                  <Link className="underline text-primary" to="/cookie-policy">
                    {translate("cookieDialogLink", lang)}
                  </Link>
                </span>
              </p>
            </span>
          </DialogContent>
          <DialogActions>
            <PspButton
              appearance="secondary"
              onClick={onConsentFunctionalCookiesOnly}
            >
              {translate("consentEssentialCookiesOnly", lang)}
            </PspButton>
            <PspButton appearance="primary" onClick={onConsentAllCookies}>
              {translate("consentAllCookies", lang)}
            </PspButton>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
